import {Autocomplete, Popper, TextField} from '@mui/material'
import {useRef, useState} from 'react'

const FullWidthPopper = (props: any) => (
  <Popper
    {...props}
    style={{...props.style, width: props.anchorEl?.offsetWidth ?? '100%', zIndex: 1400}}
  />
)

interface InstallAutocompleteProps {
  id: string
  label: string
  placeholder: string
  options: any[]
  getOptionLabel: (option: any) => string
  filterOptions?: (options: any[], state: any) => any[]
  isOptionEqualToValue?: (option: any, value: any) => boolean
  onChange: (value: any) => void
}

const InstallAutocomplete = ({
  id,
  label,
  placeholder,
  options,
  getOptionLabel,
  filterOptions,
  isOptionEqualToValue,
  onChange,
}: InstallAutocompleteProps) => {
  const [autocompleteOpen, setAutocompleteOpen] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const inputRef = useRef<HTMLInputElement | null>(null)
  const justSelectedRef = useRef(false)

  return (
    <Autocomplete
      disableCloseOnSelect={false}
      fullWidth
      id={id}
      inputValue={inputValue}
      onInputChange={(_, newValue, reason) => {
        if (reason === 'reset') {
          if (justSelectedRef.current) {
            justSelectedRef.current = false
            setInputValue(newValue)
          }
          return
        }
        setInputValue(newValue)
      }}
      open={autocompleteOpen}
      onOpen={() => setAutocompleteOpen(true)}
      onClose={(_, reason) => {
        if (reason === 'blur') return
        setAutocompleteOpen(false)
      }}
      options={options}
      className={'px-0'}
      disableClearable={true}
      clearText={'초기화'}
      noOptionsText={'검색 결과가 없습니다.'}
      getOptionLabel={getOptionLabel}
      filterOptions={filterOptions}
      isOptionEqualToValue={isOptionEqualToValue}
      PopperComponent={FullWidthPopper}
      renderOption={(props, option) => (
        <li {...props} style={{backgroundColor: '#eff6ff', borderBottom: '1px solid #dbeafe'}}>
          {getOptionLabel(option)}
        </li>
      )}
      onChange={(_, rowValue: any) => {
        justSelectedRef.current = true
        setTimeout(() => {
          if (inputRef.current) inputRef.current.blur()
        }, 100)
        onChange(rowValue)
      }}
      sx={{fontSize: '1.5rem', color: '#fff'}}
      renderInput={(params) => (
        <TextField
          {...params}
          inputRef={(ref) => {
            inputRef.current = ref
          }}
          fullWidth
          label={label}
          focused
          placeholder={placeholder}
          inputProps={{
            ...params.inputProps,
            enterKeyHint: 'done',
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') inputRef.current?.blur()
          }}
        />
      )}
    />
  )
}

export default InstallAutocomplete
